import { createReducer } from '@reduxjs/toolkit';

import {
  deleteAllNotification,
  deleteNotification,
  getMoreNotifications,
  getNotifications,
  markAllAsRead,
  markAsRead,
} from './actions';
import { NotificationState } from './types';
import { NotificationStatus } from '@rapid-recovery-agency-inc/insightt-shared';

export const INITIAL_NOTIFICATION_STATE: NotificationState = {
  currentPage: 0,
  notifications: [],
  pageSize: 0,
  totalItem: 0,
  totalPage: 0,
  totalUnread: 0,
  isNotificationLoading: true,
  isLoadingMoreNotifications: false,
  isLoadingOption: false,
};

export const notificationsReducer = createReducer(INITIAL_NOTIFICATION_STATE, (builder) => {
  builder
    .addCase(getNotifications.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        isNotificationLoading: false,
      };
    })
    .addCase(getNotifications.pending, (state) => {
      return { ...state, isNotificationLoading: true };
    })
    .addCase(getNotifications.rejected, (state) => {
      return { ...state, isNotificationLoading: false };
    })
    .addCase(getMoreNotifications.fulfilled, (state, action) => {
      const moreNotifications = action.payload?.notifications ?? [];
      return {
        ...state,
        ...action.payload,
        isLoadingMoreNotifications: false,
        notifications: [...state.notifications, ...moreNotifications],
      };
    })
    .addCase(getMoreNotifications.pending, (state) => {
      return { ...state, isLoadingMoreNotifications: true };
    })
    .addCase(getMoreNotifications.rejected, (state) => {
      return { ...state, isLoadingMoreNotifications: false };
    })
    .addCase(markAllAsRead.pending, (state) => {
      return { ...state, isNotificationLoading: true };
    })
    .addCase(markAllAsRead.rejected, (state) => {
      return { ...state, isNotificationLoading: false };
    })
    .addCase(deleteNotification.pending, (state) => {
      return { ...state, isLoadingOption: true };
    })
    .addCase(deleteNotification.fulfilled, (state, action) => {
      const notification = state.notifications.find((item) => item?.id === action.payload);
      const isNotRead = notification?.status !== NotificationStatus.READ;

      return {
        ...state,
        isLoadingOption: false,
        totalUnread: isNotRead ? state.totalUnread - 1 : state.totalUnread,
        notifications: state.notifications.filter((item) => item?.id !== action.payload),
      };
    })
    .addCase(deleteNotification.rejected, (state) => {
      return { ...state, isLoadingOption: false };
    })
    .addCase(deleteAllNotification.pending, (state) => {
      return { ...state, isNotificationLoading: true };
    })
    .addCase(deleteAllNotification.rejected, (state) => {
      return { ...state, isNotificationLoading: false };
    })
    .addCase(markAsRead.pending, (state) => {
      return { ...state, isLoadingOption: true };
    })
    .addCase(markAsRead.rejected, (state) => {
      return { ...state, isLoadingOption: false };
    })
    .addCase(markAsRead.fulfilled, (state, action) => {
      return {
        ...state,
        isLoadingOption: false,
        totalUnread: state.totalUnread - 1,
        notifications: state.notifications?.map((item) => {
          if (item?.id === action?.payload) {
            return {
              ...item,
              status: NotificationStatus.READ,
            };
          }
          return item;
        }),
      };
    })
    .addDefaultCase((state) => state);
});
